module.exports = new __parcel__URL__("AuroraLogo.5103bfbf.svg").toString();